import { List } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

export interface ServerProps {
  title?: string;
  url?: string;
}

export interface ServerInUseWarningProps {
  usedServices: ServerProps[];
}

export const ServerInUseWarning = ({ usedServices }: ServerInUseWarningProps) => {
  const [t] = useTranslation('geosecma-settings');

  return (
    <List
      size="small"
      header={<div>{t('serverInUseWarning')}</div>}
      dataSource={usedServices}
      renderItem={(item) => (
        <List.Item>
          <span data-testid="serverInUseListItem">{item.title ? item.title : item.url}</span>
        </List.Item>
      )}
    />
  );
};
